import { endOfDay, isBefore } from 'date-fns';
import { HighlightColorType } from '../../components/date-viewer/DateViewer';
import { InvoiceStatus } from '../../domain/types';

export function getCriticalIfInThePast(date: Date): HighlightColorType | undefined {
  const NOW = new Date();
  const NORMALIZED_DATE = endOfDay(new Date(date));
  return isBefore(NORMALIZED_DATE, NOW) ? 'critical' : undefined;
}

export function getPaymentDateLabel(status: InvoiceStatus | undefined): string {
  if (status === InvoiceStatus.PAID || status === InvoiceStatus.NOT_PAID) {
    return 'Data chiusura';
  }
  if (status === InvoiceStatus.COLLECTED) {
    return 'Data di incasso';
  }
  return 'Data presunta';
}
